<template lang="pug">
  div
    h1 Hello
</template>

<script>
export default {
  name: 'example'
}
</script>

<style scoped>

</style>
